<div class="widget-wrapper" [class.interactive]="config().interactive">
  @if (config().interactive && config().title) {
    <div class="widget-header">
      <span class="widget-title">{{ config().title }}</span>
      @if (topBarControls().length) {
        <div class="widget-controls">
          @for (item of topBarControls(); track $index) {
            <ng-container [ngTemplateOutlet]="controlOrGroupTemplate" [ngTemplateOutletContext]="{ item }" />
          }
        </div>
      }
    </div>
  }
  <div #widgetContainer class="widget-content"></div>
  @if (bottomBarControls().length) {
    <div class="widget-bottom-bar">
      @for (item of bottomBarControls(); track $index) {
        <ng-container [ngTemplateOutlet]="controlOrGroupTemplate" [ngTemplateOutletContext]="{ item }" />
      }
    </div>
  }
  @if (canvasOverlayControls().length) {
    <div class="widget-canvas-overlay">
      @for (item of canvasOverlayControls(); track $index) {
        <ng-container [ngTemplateOutlet]="controlOrGroupTemplate" [ngTemplateOutletContext]="{ item }" />
      }
    </div>
  }
</div>

<ng-template #controlOrGroupTemplate let-item="item">
  @if (isGroup(item)) {
    <div class="input-group">
      @for (control of item.controls; track control.id) {
        <ng-container [ngTemplateOutlet]="controlTemplate" [ngTemplateOutletContext]="{ control }" />
      }
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="controlTemplate" [ngTemplateOutletContext]="{ control: item }" />
  }
</ng-template>

<ng-template #controlTemplate let-control="control">
  @switch (control.type) {
    @case ('button') {
      <button
        class="widget-control-btn"
        [class.icon-only]="control.icon && !shouldShowLabel(control)"
        [attr.aria-label]="control.label"
        [title]="control.label"
        (click)="onButtonClick(control)"
      >
        @if (control.icon) {
          <dojo-icon [icon]="asIcon(control.icon)" />
        }
        @if (shouldShowLabel(control)) {
          <span class="btn-label">{{ control.label }}</span>
        }
      </button>
    }
    @case ('button-group') {
      <div class="button-group">
        @for (btn of control.buttons; track btn.id) {
          <button
            class="widget-control-btn segment-btn"
            [class.active]="activeButtonInGroup()[control.id] === btn.id"
            [attr.aria-label]="btn.label"
            [title]="btn.label"
            (click)="onButtonGroupClick(control, btn)"
          >
            @if (btn.icon) {
              <dojo-icon [icon]="asIcon(btn.icon)" />
            }
            @if (shouldShowLabel(btn)) {
              <span class="btn-label">{{ btn.label }}</span>
            }
          </button>
        }
      </div>
    }
    @case ('slider') {
      <dojo-slider
        [param]="control.param"
        [min]="control.min"
        [max]="control.max"
        [step]="control.step ?? 1"
        [value]="getSliderValue(control)"
        [editable]="control.editable ?? false"
        [color]="control.color ?? 'sky'"
        (valueChange)="onSliderChange(control, $event)"
      />
    }
    @case ('slider-group') {
      <div class="slider-group">
        @for (slider of control.sliders; track slider.id) {
          <dojo-slider
            [param]="slider.param"
            [min]="slider.min"
            [max]="slider.max"
            [step]="slider.step ?? 1"
            [value]="getSliderGroupValue(control, slider.id)"
            [editable]="slider.editable ?? false"
            [color]="slider.color ?? 'sky'"
            (valueChange)="onSliderGroupChange(control, { id: slider.id, value: $event })"
          />
        }
      </div>
    }
    @case ('math-input') {
      <dojo-math-input
        [param]="control.param"
        [value]="getMathInputValue(control)"
        (valueChange)="onMathInputChange(control, $event)"
      />
    }
  }
</ng-template>
